module.exports = __webpack_public_path__ + "img/autospin_btn.66f8572d.png";